import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AnalyticsEvent, AnalyticsService } from '@mode/shared/util-segment';
import * as SchemaBrowserActions from './browser.actions';
import { differenceInMinutes } from 'date-fns';
import { ToastService } from '@mode/shared/util-toast';

@Injectable({ providedIn: 'root' })
export class SchemaBrowserFacade {
  constructor(private store: Store, private analyticsService: AnalyticsService, private toastService: ToastService) {}

  public notifyUserAboutError(dataSourceCreatedAt: Date): void {
    if (differenceInMinutes(new Date(), dataSourceCreatedAt) < 2) {
      this.toastService.info(`Schema update in progress`);
    } else {
      this.toastService.error('Unable to load more schemas. Please try again.');
    }
  }

  public showMoreSchemasClicked(reportToken: string): void {
    this.store.dispatch(
      SchemaBrowserActions.showMoreSchemasClicked({
        context: this.analyticsService.context,
        buttonClicked: 'show more schemas',
        reportToken,
      })
    );
  }

  public showMoreTablesClicked(reportToken: string): void {
    this.store.dispatch(
      SchemaBrowserActions.showMoreTablesClicked({
        context: this.analyticsService.context,
        buttonClicked: 'show more tables',
        reportToken,
      })
    );
  }
}
